import Model from 'flarum/common/Model';
export default class Flag extends Model {
  type() {
    return Model.attribute('type').call(this);
  }
  reason() {
    return Model.attribute('reason').call(this);
  }
  reasonDetail() {
    return Model.attribute('reasonDetail').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
}
flarum.reg.add('flarum-flags', 'forum/models/Flag', Flag);